import React, { memo, useCallback, useMemo } from 'react';

import Text from 'containers/components/Fields/Text';
import { getLiteral } from 'utils/getLiteral';

const Periods = memo(({ data, errors, field, getError, onChange }) => {
    // ========================================
    // EVENT HANDLERS & CALLBACKS
    // ========================================
    const handleOnChange = useCallback(
        (id) => {
            return (value) => {
                const newValues = {
                    ...data.valuesDefined,
                    [id]: value,
                };
                onChange && onChange(newValues);
            };
        },
        [data.valuesDefined, onChange],
    );

    // ========================================
    // RENDER
    // ========================================
    const renderFields = useMemo(() => {
        return field.fields.map((current) => {
            return (
                <Text
                    key={current.id}
                    error={getError(errors[current.id], [current.dataLength])}
                    label={getLiteral(current.label)}
                    labelMode="horizontal"
                    mandatory={current.mandatory}
                    onChange={handleOnChange(current.id)}
                    type="number"
                    value={data?.valuesDefined?.[current.id] || ''}
                />
            );
        });
    }, [data, errors, field.fields, getError, handleOnChange]);

    if (!field?.fields || field?.fields.length === 0) return null;

    return <div className="periods-field-container">{renderFields}</div>;
});

Periods.displayName = 'Periods';

export default Periods;
